
angular.module('bmsApp.training').controller('TrainingProviderModalFormCtrl', [
	'$log',
	'$scope',
	'$q',
	'$modalInstance',
	'$ngBootbox',
	'TrainingProviderSvc',
	'training_provider',
	function (
		$log,
		$scope,
		$q,
		$modalInstance,
		$ngBootbox,
		TrainingProviderSvc,
		training_provider) {

		var trainingProviderOptionsPromise = TrainingProviderSvc.options();
		var promises = [trainingProviderOptionsPromise];
		$scope.loading = true;
		$scope.processing = false;
		$q.all(promises).then(function (responses) {
			$scope.training_provider = angular.copy(training_provider);
			$scope.trainingProviderOptions = responses[0].data.options;
			$scope.loading = false;
		}, function (error) {
			$log.error(error);
		});

		$scope.formvalidatorconfig = {
			submitHandler: function (form) {
				$scope.submit($scope.training_provider);
			},
			errorPlacement: function (error, element) {
				error.appendTo('#training-provider-errors');
			},
			errorContainer: '#training-provider-errors'
		};

		$scope.trainingProviderSelected = function (selected_training_provider) {
			$scope.training_provider = angular.copy(selected_training_provider);
		};

		$scope.submit = function (training_provider) {
			$scope.processing = true;
			var modalResult = {};
			var savePromise = training_provider.id ? TrainingProviderSvc.update(training_provider.id, training_provider) : TrainingProviderSvc.create(training_provider);
			savePromise
				.then(function (response) {
					modalResult.success = response.data.success;
					modalResult.action = training_provider.id ? 'update' : 'create';
					modalResult.training_provider = training_provider;
					$modalInstance.close(modalResult);
				}, function (error) {
					modalResult.error = error;
					$modalInstance.close(modalResult);
				})
				.finally(function () {
					$scope.processing = false;
				});
		};

		$scope.delete = function (training_provider) {
			$ngBootbox.confirm('Are you sure you want to do this?')
				.then(function () {
					var modalResult = {};
					TrainingProviderSvc.delete(training_provider.id)
						.then(function (response) {
							modalResult.success = response.data.success;
							modalResult.action = 'delete';
							$modalInstance.close(modalResult);
						}, function (error) {
							modalResult.error = error;
							$modalInstance.close(modalResult);
						});
				});
		};

		$scope.cancel = function () {
			$modalInstance.dismiss('cancel');
		};

	}]);
